export default function AboutMe() {
    return (
        <section className="about-me" id="about">
            <h2>About Me</h2>
            <div className="about-text">
                <p>💡 I transitioned from Application Engineer to Frontend Engineer by building projects, focusing on system design and deepening my Javascript expertise.</p>
                <p>✅ I value code simplicity, accessibility, and obsess over customer experience.</p>
            </div>
        </section>
    )
}
